import type { QueryClient, QueryKey } from "@tanstack/react-query";

type MarkBrandOnboardingCompleteInCacheInput = {
  brandId: string;
  brandSearchActivityKey: QueryKey;
  queryClient: QueryClient;
  organizationHasSearchExecutionsKey: QueryKey;
  brandSearchExecutionCountKey: QueryKey;
  searchSpecificationId: string;
};

export const hasCompletedBrandOnboarding = (
  searchExecutionCount: number | null | undefined,
): boolean => (searchExecutionCount ?? 0) > 0;

export const markBrandOnboardingCompleteInCache = ({
  brandId,
  brandSearchActivityKey,
  queryClient,
  organizationHasSearchExecutionsKey,
  brandSearchExecutionCountKey,
  searchSpecificationId,
}: MarkBrandOnboardingCompleteInCacheInput): void => {
  queryClient.setQueryData<boolean>(organizationHasSearchExecutionsKey, true);
  queryClient.setQueryData<number>(brandSearchExecutionCountKey, (previousCount) =>
    Math.max(previousCount ?? 0, 1),
  );
  queryClient.setQueryData(brandSearchActivityKey, {
    activeExecutionCount: 1,
    brandId,
    failureReason: null,
    finalizedAt: null,
    id: `optimistic-${searchSpecificationId}`,
    isActive: true,
    phase: "preparing",
    phaseLabel: "Preparing search",
    progressCurrent: 0,
    progressPercentage: null,
    progressStep: "generating",
    progressTotal: null,
    searchSpecificationId,
    startedAt: new Date(),
    status: "PENDING_DISPATCH",
    updatedAt: new Date(),
  });
};
